import type { FaireProductEntity } from "../../entity_types/product";

export const p_zuc3bab8re: FaireProductEntity = {
  token: "p_zuc3bab8re",
  type: "product",
  name: "All About Peter",
  brandToken: "b_q68qsrd57c",
  brandName: "Penguin Random House LLC",
  imageUrl: "https://cdn.faire.com/fastly/f8284fb1163ac3446752f1e4e11f4438db62c4b0c446095b5fb621ad77da0d4e.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description: "Spend a day with Peter Rabbit in this shaped board book as Peter plays outside, meets up with friends, and finally gets ready for bed. Cute rhyming text and rabbit-shaped pages make this a new classic book for the smallest fans of Beatrix Potter--and a perfect introduction to the classic world of Peter Rabbit.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:39.819Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
